import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Checkbox, Button, Tooltip, Box
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { toast } from 'react-toastify';
import axios from 'axios';
import UtmDetails from '../common/UtmDetails';

const truncateMessage = (msg, words = 3) => {
  if (typeof msg !== 'string') return '';
  const parts = msg.split(' ');
  return parts.slice(0, words).join(' ') + (parts.length > words ? '...' : '');
};

const ContactTable = ({ contacts, selectedContacts, handleSelect, fetchContacts }) => {
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this contact?')) {
      try {
        await axios.delete(`/api/v1/contact/delete-contact/${id}`);
        toast.success('Contact deleted successfully');
        fetchContacts();
      } catch (err) {
        console.error('Delete error:', err);
        toast.error('Failed to delete contact');
      }
    }
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        border: '1px solid rgba(0,0,0,0.05)',
        overflow: 'hidden',
        '& .MuiTable-root': {
          minWidth: 650,
        }
      }}
    >
      <Table>
        <TableHead>
          <TableRow sx={{
            background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
            '& .MuiTableCell-root': {
              color: 'white',
              fontWeight: 600,
              fontSize: '0.875rem',
              letterSpacing: '0.5px',
              borderBottom: 'none',
              py: 1.5
            }
          }}>
            <TableCell sx={{ width: 60, borderTopLeftRadius: '8px' }}>Select</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Message</TableCell>
            <TableCell>UTM</TableCell>
            <TableCell sx={{ borderTopRightRadius: '8px' }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {contacts.map((contact) => (
            <TableRow
              key={contact.id}
              hover
              sx={{
                '&:last-child td': { borderBottom: 0 },
                '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.03)' },
                backgroundColor: selectedContacts[contact.id] ? 'rgba(25, 118, 210, 0.08)' : 'inherit'
              }}
            >
              <TableCell>
                <Checkbox
                  checked={!!selectedContacts[contact.id]}
                  onChange={() => handleSelect(contact)}
                  sx={{
                    color: '#1976d2',
                    '&.Mui-checked': {
                      color: '#1976d2',
                    },
                  }}
                />
              </TableCell>
              <TableCell sx={{ fontWeight: 500 }}>{contact.user_name}</TableCell>
              <TableCell sx={{ color: '#1976d2' }}>{contact.email}</TableCell>
              <TableCell>{new Date(contact.createdAt).toLocaleDateString()}</TableCell>
              <TableCell>
                <Tooltip title={contact.message || ''} arrow>
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      maxWidth: 200,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      color: 'text.secondary'
                    }}
                  >
                    {truncateMessage(contact.message)}
                  </Box>
                </Tooltip>
              </TableCell>
              <TableCell sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
                <UtmDetails row={contact} />
              </TableCell>
              <TableCell>
                <Tooltip title="Delete" arrow>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => handleDelete(contact.id)}
                    sx={{
                      minWidth: 'auto',
                      p: 1,
                      borderRadius: 1,
                      borderWidth: 2,
                      '&:hover': {
                        backgroundColor: 'rgba(239, 68, 68, 0.08)',
                        borderWidth: 2
                      }
                    }}
                  >
                    <DeleteForeverIcon fontSize="small" />
                  </Button>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ContactTable;